import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { distributionUrl } from "../../../Config/url";
import { useAxiosConfigGlobal } from "../../../Config/axios";
import assets from "../../../../assets/assets";
import { IconController, ImgController } from "../../../Scripts/ImgController";
import Skeleton from "react-loading-skeleton";
import Ripples from "react-ripples";
import PDFViewer from "./PDFViewer";

const Wrapper = styled.div`
  .container {
    position: relative;
    border: 1px solid #d1d5db;
    border-radius: 12px;
    overflow: hidden;
  }
  .pdf-container {
    width: 100%;
    height: 100%;
    box-shadow: 0px 4px 6px 3px #00000040;
  }

  .controls {
    background: #f3f4f6;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 80px;
    padding: 16px 0;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom: 1px solid #d1d5db;
  }
  .pagination {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  .zoom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  input[type="number"] {
    border-radius: 6px;
    width: 32px;
    height: 24px;
    border: 1px solid #d1d5db;
    appearance: textfield;
    -moz-appearance: textfield;
    padding-left: 8px;
    font-size: 12px;
    font-weight: 500;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .zoom-button {
    border: 1px solid #d1d5db;
    background-color: #ffffff;
    padding: 4px;
    border-radius: 6px;
    cursor: pointer;
  }
  .zoom-button:hover {
    background: #0061ff40;
  }
  .popup-selection {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    margin: auto;
    padding: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
    background: #ffffff;
  }
  // .control-button {
  //   cursor: pointer;
  //   width: 20px;
  //   height: 20px;
  //   background: none;
  //   border-radius: 4px;
  // }
  // .control-button:hover {
  //   background: #0061ff40;
  // }
`;
const Popup = styled.div`
  position: absolute;
  bottom: 0;
  top: 140px;
  z-index: 103 !important;
  .modal {
    width: 150px;
    height: 150px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    padding: 8px 0;
    overflow-y: scroll;
    bottom: 0;
    position: absolute;
  }
  .modal::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
`;
const Contract = ({ oneRingRulesAll }) => {
  const [zoomPopup, setZoomPopup] = useState(false);
  const [allFiles, setAllFiles] = useState([]);
  const [currentFile, setCurrentFile] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);

  const [pdfWidth, setPdfWidth] = useState(0);
  const [pdfScale, setPdfScale] = useState(0.75);
  const [pdfStream, setPdfStream] = useState(null);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);
  const axiosConfig = useAxiosConfigGlobal();
  const zoomScales = [
    { scale: 0.5 },
    { scale: 0.75 },
    { scale: 1 },
    { scale: 1.25 },
    { scale: 1.5 },
    { scale: 1.75 },
    { scale: 2 },
  ];

  const streamFile = async (filePath) => {
    if (!filePath) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${distributionUrl}stream/panel/file?url=true&path=${filePath}`,
        axiosConfig
      );
      setPdfStream(response.data.url);
    } catch (error) {
      console.error("Failed to stream file:", error);
    } finally {
      setLoading(false);
    }
  };

  function pageChanged(pageNumber) {
    setCurrentFile(allFiles[pageNumber]);
    streamFile(allFiles[pageNumber]?.path);
    setCurrentIndex(pageNumber);
  }

  useEffect(() => {
    document.title = "MMusic - Профайл - Гэрээний төрөл";
    setLoading(true);

    axios
      .get(
        `${distributionUrl}panel-api/oauth/agreement:attachments`,
        axiosConfig
      )
      .then((res) => {
        if (res.data?.data?.length > 0) {
          setAllFiles(res.data.data);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (allFiles.length > 0) {
      pageChanged(0);
    }
  }, [allFiles]);

  useEffect(() => {
    setPdfWidth(containerRef?.current?.offsetWidth);
  }, [containerRef?.current?.offsetWidth]);

  const nextPageHandler = () => {
    if (allFiles.length - 1 !== currentIndex) {
      setLoading(true);
      pageChanged(currentIndex + 1);
    }
  };

  const prevPageHandler = () => {
    if (currentIndex !== 0) {
      setLoading(true);
      pageChanged(currentIndex - 1);
    }
  };

  const zoomOutHandler = () => {
    if (pdfScale >= 0.26) {
      setPdfScale(pdfScale - 0.25);
    }
  };
  const zoomInHandler = () => {
    if (pdfScale <= 1.99) {
      setPdfScale(pdfScale + 0.25);
    }
  };
  return (
    <Wrapper ref={containerRef} className={`px-6 py-8 `}>
      <div className="container">
        <div className="controls">
          <div className="pagination">
            <Ripples color="#0061ff40" during={600} className="rounded-sm">
              <div
                className="control-button"
                onClick={() => {
                  prevPageHandler();
                }}
              >
                <IconController
                  src={assets.svg.pdfPrevOne}
                  className="w-5 h-5"
                />
              </div>
            </Ripples>
            <div className="flex flex-row gap-3 items-center justify-center">
              <span className="text-xs font-medium">Нийт файл</span>

              <span className="text-xs font-medium">
                {currentIndex + 1}&nbsp;/&nbsp;{allFiles.length}
              </span>
            </div>
            <Ripples color="#0061ff40" during={600} className="rounded-sm">
              <div
                className="control-button"
                onClick={() => {
                  nextPageHandler();
                }}
              >
                <IconController
                  src={assets.svg.pdfNextOne}
                  className="w-5 h-5"
                />
              </div>
            </Ripples>
          </div>
          {currentFile?.mime_type === "application/pdf" ? (
            <div className="zoom">
              <Ripples color="#0061ff40" during={600} className="rounded-sm">
                <div
                  className="zoom-button"
                  onClick={() => {
                    zoomOutHandler();
                  }}
                >
                  <IconController
                    src={assets.svg.pdfZoomOut}
                    className="w-5 h-5"
                  />
                </div>
              </Ripples>
              <Ripples color="#0061ff40" during={600} className="rounded-sm">
                <div
                  className="zoom-button"
                  onClick={() => {
                    zoomInHandler();
                  }}
                >
                  <IconController
                    src={assets.svg.pdfZoomIn}
                    className="w-5 h-5"
                  />
                </div>
              </Ripples>

              <div>
                <Ripples color="#0061ff40" during={600} className="rounded-lg">
                  <div className="flex flex-row justify-between">
                    <div
                      className="popup-selection"
                      onClick={() => {
                        setZoomPopup(true);
                      }}
                    >
                      <h5 className="font-semibold text-xs">
                        {pdfScale * 100 + "%"}
                      </h5>
                      <IconController
                        src={assets.svg.pdfChevronDown}
                        className="w-4 h-4"
                      />
                    </div>
                    <div className="flex-1"></div>
                  </div>
                </Ripples>
                {zoomPopup ? (
                  <div
                    className="relative"
                    style={{ zIndex: "10002 !important" }}
                  >
                    <Overlay
                      onClick={() => {
                        setZoomPopup(false);
                      }}
                    ></Overlay>

                    <Popup>
                      <div className="modal">
                        <div className="flex flex-col gap-2">
                          {zoomScales.map((zoom) => {
                            return (
                              <Ripples
                                color="#0061ff40"
                                during={600}
                                className="rounded-sm"
                                key={zoom.scale}
                              >
                                <div
                                  className="px-4 py-1 w-full cursor-pointer"
                                  onClick={() => {
                                    setPdfScale(zoom.scale);
                                  }}
                                >
                                  <h5 className="font-semibold text-xs">
                                    {zoom.scale * 100 + "%"}
                                  </h5>
                                </div>
                              </Ripples>
                            );
                          })}
                        </div>
                      </div>
                    </Popup>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            " "
          )}
        </div>
        <div className="flex justify-center min-h-[80vh]">
          {loading ? (
            <div className="px-24 py-8 w-[738px] absolute z-50 ">
              <div className="flex justify-center items-center pt-20">
                <div className=" w-12 h-12 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
              </div>
            </div>
          ) : (
            <>
              <div className="p-8 min-h-[80vh] h-full w-full flex justify-center overflow-scroll">
                {currentFile?.mime_type === "application/pdf" ? (
                  <PDFViewer
                    pdfFile={pdfStream}
                    pdfWidth={pdfWidth}
                    pdfScale={pdfScale}
                  />
                ) : (
                  ""
                )}
                {currentFile?.mime_type === "image/jpeg" ? (
                  // <div className="p-8 min-h-[70vh] h-full w-full flex justify-center">
                  <div className="overflow-auto max-h-[70vh]">
                    <ImgController
                      src={pdfStream}
                      className="h-fit w-full shadow-xl"
                    />
                  </div>
                ) : (
                  // </div>
                  ""
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default Contract;
